export default __webpack_public_path__ + "static/media/home-grey.2fb72cf0.svg";